import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getIdegenNyelviKorulmenyek, createIdegenNyelviKorulmenyek, updateIdegenNyelviKorulmenyek, getSzak } from "../../apis/SzakokFinder";
// import "../../components/Ujszak.css";
import SideTile from "../SideTile";
import { useDropzone } from "react-dropzone";
// import "./IdegenNyelviKorulmenyek.css";
import "./SzakjelentesCreate.css";
import "./RadioButton.css";
import RichTextEditor from "../RichTextEditor";
import { useFormSave } from "../../context/FormSaveContext";
import TopAlert from '../../components/TopAlert';
import { LanguageProvider, useLanguage } from "../../context/LanguageContext";
import { IDEGENNYELVIKORULMENYEK_TRANSLATIONS } from './IdegenNyelviKorulmenyekTranslations';
import { HALLGATOK_ARANYA_OPTIONS, ELOZO_EVEK_OPTIONS, NEMZETKOZI_HALLGATOK_OPTIONS, MOBILITAS_HOZZAJARULASA_OPTIONS, MOBILITASI_ABLAK_OPTIONS, KREDIT_ELISMERES_OPTIONS, ALTALANOS_NYELVI_OPTIONS, SZAKNYELVI_TARGYAK_OPTIONS, IDEGEN_NYELV_OPTIONS } from './IdegenNyelviKorulmenyekOptions';


const IdegenNyelviKorulmenyekContent = ({ szakKod }) => {
    const { language, loading } = useLanguage();
    const [isSideTileVisible] = useState(true); // Added state for controlling SideTile visibility
    const { registerSaveHandler, unregisterSaveHandler } = useFormSave();

    const { szakId } = useParams();
    const navigate = useNavigate();
    const sideTileRef = useRef(null);

    // Top alert state
    const [showAlert, setShowAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState("");

    const [idegenNyelviKorulmenyek, setIdegenNyelviKorulmenyek] = useState({
        filling_status: 1
    });

    const [hallgatokAranya, setHallgatokAranya] = useState("");
    const [elozoEvek, setElozoEvek] = useState("");
    const [nemzetkoziHallgatok, setNemzetkoziHallgatok] = useState("");
    const [mobilitasHozzajarulasa, setMobilitasHozzajarulasa] = useState([]); // Changed to array for checkboxes
    const [mobilitasHozzajarulasaEgyeb, setMobilitasHozzajarulasaEgyeb] = useState("");
    const [mobilitasiAblak, setMobilitasiAblak] = useState("");
    const [mobilitasiAblakMegjegyzes, setMobilitasiAblakMegjegyzes] = useState("");
    const [kreditElismeres, setKreditElismeres] = useState([]);
    const [kreditElismeresEgyeb, setKreditElismeresEgyeb] = useState("");
    const [altalanosNyelvi, setAltalanosNyelvi] = useState("");
    const [szaknyelviTargyak, setSzaknyelviTargyak] = useState("");
    const [idegenNyelv, setIdegenNyelv] = useState("");

    const [images, setImages] = useState({
        hallgato_mobilitas_image: [],
        idegen_szaknyelv_image: []
    });

    const [isNew, setIsNew] = useState(true);
    const [selectedImage, setSelectedImage] = useState(null);
    const [finalized, setFinalized] = useState(false);
    const [szakStatus, setSzakStatus] = useState(1); // Mely státuszban van a szakjelentés

    // Translations and options setup
    const t = loading ? {} : (IDEGENNYELVIKORULMENYEK_TRANSLATIONS[language] || IDEGENNYELVIKORULMENYEK_TRANSLATIONS.hu);
    const hallgatokAranyaOptions = loading ? [] : (HALLGATOK_ARANYA_OPTIONS[language] || HALLGATOK_ARANYA_OPTIONS.hu);
    const elozoEvekOptions = loading ? [] : (ELOZO_EVEK_OPTIONS[language] || ELOZO_EVEK_OPTIONS.hu);
    const nemzetkoziHallgatokOptions = loading ? [] : (NEMZETKOZI_HALLGATOK_OPTIONS[language] || NEMZETKOZI_HALLGATOK_OPTIONS.hu);
    const mobilitasHozzajarulasaOptions = loading ? [] : (MOBILITAS_HOZZAJARULASA_OPTIONS[language] || MOBILITAS_HOZZAJARULASA_OPTIONS.hu);
    const mobilitasiAblakOptions = loading ? [] : (MOBILITASI_ABLAK_OPTIONS[language] || MOBILITASI_ABLAK_OPTIONS.hu);
    const kreditElismeresOptions = loading ? [] : (KREDIT_ELISMERES_OPTIONS[language] || KREDIT_ELISMERES_OPTIONS.hu);
    const altalanosNyelviOptions = loading ? [] : (ALTALANOS_NYELVI_OPTIONS[language] || ALTALANOS_NYELVI_OPTIONS.hu);
    const szaknyelviTargyakOptions = loading ? [] : (SZAKNYELVI_TARGYAK_OPTIONS[language] || SZAKNYELVI_TARGYAK_OPTIONS.hu);
    const idegenNyelvOptions = loading ? [] : (IDEGEN_NYELV_OPTIONS[language] || IDEGEN_NYELV_OPTIONS.hu);
    const isHungarian = language === 'hu';

    // Helper function to build JSONB structure
    const buildRadioData = (selectedValue, options) => {
        if (!selectedValue) return null;
        return {
            selected: selectedValue,
            options: options
        };
    };

    // Helper function to build JSONB structure for multi-select checkboxes
    const buildMultiSelectData = (selectedValues, options) => {
        if (!selectedValues || selectedValues.length === 0) return null;
        return {
            selected: selectedValues,
            options: options
        };
    };

    const handleMobilitasiAblakMegjegyzes = (value) => {
        setMobilitasiAblakMegjegyzes(value);
    };

    useEffect(() => {
        const fetchData = async () => {
            // Guard: only proceed if szakId is available
            if (!szakId) {
                return;
            }

            try {
                // Lekérjük a szak adatait a státusz beállításához
                const szakResponse = await getSzak(szakId);
                if (szakResponse.data && szakResponse.data.data) {
                    setSzakStatus(szakResponse.data.data.status);
                }

                const response = await getIdegenNyelviKorulmenyek(szakId);
                const rawData = response.data.data.idegenNyelviKorulmenyek;
                if (rawData && rawData.length > 0) {
                    const data = rawData[0];

                    // Backend returns a placeholder row with filling_status = 0 when no record exists yet
                    if (data.filling_status === 0) {
                        const newData = { filling_status: 1 };
                        const createResponse = await createIdegenNyelviKorulmenyek(szakId, newData);
                        setIdegenNyelviKorulmenyek(createResponse.data);
                        setIsNew(false);
                        setFinalized(false);
                        window.location.reload();
                        return;
                    }

                    setIdegenNyelviKorulmenyek(data);
                    setFinalized(data.filling_status === 3);
                    await fetchImages();

                    if (data.hallgatok_aranya) setHallgatokAranya(data.hallgatok_aranya.selected || "");
                    if (data.elozo_evek) setElozoEvek(data.elozo_evek.selected || "");
                    if (data.nemzetkozi_hallgatok) setNemzetkoziHallgatok(data.nemzetkozi_hallgatok.selected || "");
                    if (data.mobilitas_hozzajarulasa) setMobilitasHozzajarulasa(data.mobilitas_hozzajarulasa.selected || []);
                    if (data.mobilitas_hozzajarulasa_egyeb) setMobilitasHozzajarulasaEgyeb(data.mobilitas_hozzajarulasa_egyeb);
                    if (data.mobilitasi_ablak) setMobilitasiAblak(data.mobilitasi_ablak.selected || "");
                    if (data.mobilitasi_ablak_megjegyzes) setMobilitasiAblakMegjegyzes(data.mobilitasi_ablak_megjegyzes || "");
                    if (data.kredit_elismeres) setKreditElismeres(data.kredit_elismeres.selected || []);
                    if (data.kredit_elismeres_egyeb) setKreditElismeresEgyeb(data.kredit_elismeres_egyeb);
                    if (data.altalanos_nyelvi) setAltalanosNyelvi(data.altalanos_nyelvi.selected || "");
                    if (data.szaknyelvi_targyak) setSzaknyelviTargyak(data.szaknyelvi_targyak.selected || "");
                    if (data.idegen_nyelv) setIdegenNyelv(data.idegen_nyelv.selected || "");

                    setIsNew(false);
                } else {
                    // Only create new record if this is the first time (no record exists yet)
                    if (isNew) {
                        const newData = { filling_status: 1 };
                        await createIdegenNyelviKorulmenyek(szakId, newData);
                        window.location.reload();
                    }
                }
            } catch (error) {
                // Only log errors that are not 404 (404 is expected when creating new records)
                if (error.response?.status !== 404) {
                    console.error("Error fetching data:", error);
                }
                if (error.response && error.response.status === 404) {
                    // Only create new record if this is the first time
                    if (isNew) {
                        const newData = { filling_status: 1 };
                        await createIdegenNyelviKorulmenyek(szakId, newData);
                        window.location.reload();
                    }
                }
            }
        };
        fetchData();
    }, [szakId, isNew]);

    const fetchImages = async () => {
        try {
            const mobilitasImages = await fetchImagesBySection("hallgato_mobilitas_image");
            const szaknyelvImages = await fetchImagesBySection("idegen_szaknyelv_image");

            setImages({
                hallgato_mobilitas_image: mobilitasImages,
                idegen_szaknyelv_image: szaknyelvImages
            });
        } catch (error) {
            console.error("Error fetching images:", error);
        }
    };

    const fetchImagesBySection = async (section) => {
        try {
            const token = localStorage.getItem('token');
            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            const response = await fetch(`${baseUrl}/szakok/${szakId}/images/${section}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error('Failed to fetch images');
            }

            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error(`Error fetching images for section ${section}:`, error);
            return [];
        }
    };


    const handleChange = (field, value) => {
        setIdegenNyelviKorulmenyek(prevState => ({
            ...prevState,
            [field]: value, // Save the updated HTML content
        }));
    };

    const handleDrop = async (acceptedFiles, section) => {
        if (finalized) return; // Disable image upload if finalized
        const formData = new FormData();
        formData.append('image', acceptedFiles[0]);
        formData.append('section', section);

        try {
            if (isNew) {
                const response = await createIdegenNyelviKorulmenyek(szakId, idegenNyelviKorulmenyek);
                setIsNew(false);
                setIdegenNyelviKorulmenyek(response.data);
            }

            const baseUrl = process.env.REACT_APP_API_BASE_URL; // Környezeti változó használata
            // Token nélküli feltöltési kérés
            const response = await fetch(`${baseUrl}/upload/${szakId}`, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                throw new Error('Failed to upload image');
            }

            const uploadResponse = await response.json();

            if (uploadResponse && uploadResponse.image_path) {
                const imagePath = uploadResponse.image_path.replace('uploads/', '');
                setImages((prevImages) => ({
                    ...prevImages,
                    [section]: [...prevImages[section], { ...uploadResponse, image_path: imagePath }]
                }));
            } else {
                console.error('Unexpected response format:', uploadResponse);
            }
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };


    const handleDeleteImage = async (imageId, section) => {
        if (finalized) return; // Disable image deletion if finalized

        try {
            const baseURL = process.env.REACT_APP_API_BASE_URL;
            await fetch(`${baseURL}/szakjelentes_letrehozas/${szakId}/images/${imageId}`, {
                method: 'DELETE',
            });

            setImages((prevImages) => ({
                ...prevImages,
                [section]: prevImages[section].filter(img => img.id !== imageId)
            }));
        } catch (error) {
            console.error('Error deleting image:', error);
        }
    };


    const handleNext = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/kotelezo-szakmai-gyakorlat`);
    };

    const handleBack = () => {
        navigate(`/szakjelentes_letrehozas/${szakId}/tehetseges-hallgatok`);
    };

    // Register auto-save handler for token expiry
    useEffect(() => {
        const autoSaveHandler = async () => {
            const updatedData = { 
                ...idegenNyelviKorulmenyek, 
                filling_status: 2,
                hallgatok_aranya: buildRadioData(hallgatokAranya, hallgatokAranyaOptions),
                elozo_evek: buildRadioData(elozoEvek, elozoEvekOptions),
                nemzetkozi_hallgatok: buildRadioData(nemzetkoziHallgatok, nemzetkoziHallgatokOptions),
                mobilitas_hozzajarulasa: buildMultiSelectData(mobilitasHozzajarulasa, mobilitasHozzajarulasaOptions),
                mobilitas_hozzajarulasa_egyeb: mobilitasHozzajarulasaEgyeb,
                mobilitasi_ablak: buildRadioData(mobilitasiAblak, mobilitasiAblakOptions),
                mobilitasi_ablak_megjegyzes: mobilitasiAblakMegjegyzes, 
                kredit_elismeres: buildMultiSelectData(kreditElismeres, kreditElismeresOptions),
                kredit_elismeres_egyeb: kreditElismeresEgyeb,
                altalanos_nyelvi: buildRadioData(altalanosNyelvi, altalanosNyelviOptions),
                szaknyelvi_targyak: buildRadioData(szaknyelviTargyak, szaknyelviTargyakOptions),
                idegen_nyelv: buildRadioData(idegenNyelv, idegenNyelvOptions),
            };
            try {
                if (isNew) {
                    await createIdegenNyelviKorulmenyek(szakId, updatedData);
                    setIsNew(false);
                } else {
                    await updateIdegenNyelviKorulmenyek(szakId, updatedData);
                }
            } catch (error) {
                console.error("Error auto-saving data:", error);
            }
        };

        registerSaveHandler(autoSaveHandler);

        return () => {
            unregisterSaveHandler();
        };
    }, [idegenNyelviKorulmenyek, isNew, szakId, registerSaveHandler, unregisterSaveHandler, hallgatokAranya, elozoEvek, nemzetkoziHallgatok, mobilitasHozzajarulasa, mobilitasHozzajarulasaEgyeb, mobilitasiAblak, mobilitasiAblakMegjegyzes, kreditElismeres, kreditElismeresEgyeb, altalanosNyelvi, szaknyelviTargyak, idegenNyelv]);

    const handleSubmit = async (e, status) => {
        e.preventDefault();
        const updatedData = { 
            ...idegenNyelviKorulmenyek,  
            filling_status: status,
            hallgatok_aranya: buildRadioData(hallgatokAranya, hallgatokAranyaOptions),
            elozo_evek: buildRadioData(elozoEvek, elozoEvekOptions),
            nemzetkozi_hallgatok: buildRadioData(nemzetkoziHallgatok, nemzetkoziHallgatokOptions),
            mobilitas_hozzajarulasa: buildMultiSelectData(mobilitasHozzajarulasa, mobilitasHozzajarulasaOptions),
            mobilitas_hozzajarulasa_egyeb: mobilitasHozzajarulasaEgyeb,
            mobilitasi_ablak: buildRadioData(mobilitasiAblak, mobilitasiAblakOptions),
            mobilitasi_ablak_megjegyzes: mobilitasiAblakMegjegyzes,
            kredit_elismeres: buildMultiSelectData(kreditElismeres, kreditElismeresOptions),
            kredit_elismeres_egyeb: kreditElismeresEgyeb,
            altalanos_nyelvi: buildRadioData(altalanosNyelvi, altalanosNyelviOptions),
            szaknyelvi_targyak: buildRadioData(szaknyelviTargyak, szaknyelviTargyakOptions),
            idegen_nyelv: buildRadioData(idegenNyelv, idegenNyelvOptions)
        };

        try {
            if (isNew) {
                const response = await createIdegenNyelviKorulmenyek(szakId, updatedData);
                setIdegenNyelviKorulmenyek(response.data);
                setIsNew(false);
            } else {
                const response = await updateIdegenNyelviKorulmenyek(szakId, updatedData);
                setIdegenNyelviKorulmenyek(response.data);
            }
            setFinalized(status === 3);
            window.location.reload();
        } catch (error) {
            console.error("Error submitting data:", error);
            alert("Error submitting data.");
        }
    };

    const isFormValid = () => {
        // Helper function to check if HTML content has actual text
        const hasContent = (html) => {
            if (!html) return false;
            // Remove HTML tags and check if there's actual text
            const text = html.replace(/<[^>]*>/g, '').trim();
            return text.length > 0;
        };

        const baseRequiredSelections =
            hallgatokAranya &&
            elozoEvek &&
            nemzetkoziHallgatok &&
            mobilitasHozzajarulasa.length > 0 &&
            mobilitasiAblak &&
            kreditElismeres.length > 0;

        const section43RequiredSelections =
            !isHungarian || (altalanosNyelvi && szaknyelviTargyak && idegenNyelv);

        const hasAllRequiredSelections = baseRequiredSelections && section43RequiredSelections;

        // Check "egyéb" text fields only if "egyéb" is selected
        const egyebFieldsValid = 
            (!mobilitasHozzajarulasa.includes('egyeb') || hasContent(mobilitasHozzajarulasaEgyeb)) && 
            (!kreditElismeres.includes('egyeb') || hasContent(kreditElismeresEgyeb));

        return (
            hasAllRequiredSelections && egyebFieldsValid
        );
    };

    const handleFinalize = (e) => {
        if (isFormValid()) {
            handleSubmit(e, 3);
        } else {
            setAlertMessage(t.alerts.requiredFields);
            setShowAlert(true);
        }
    };

    const handleRevertFinalize = (e) => {
        handleSubmit(e, 2);
    };

    // Show loading state while language context is initializing
    if (loading) {
        return <div>Loading language...</div>;
    }

    return (
        <div className="szakjelentes-create-wrapper">
        <div className="uj-szak-page">
            {showAlert && (
                <TopAlert message={alertMessage} onClose={() => setShowAlert(false)} duration={5000} />
            )}
            <SideTile ref={sideTileRef} id={szakId} texts={t.sidebar}
                isVisible={isSideTileVisible}
            />
            <div className="uj-szak-container">
                <h1>{t.pageTitle}</h1>
                <form onSubmit={(e) => handleSubmit(e, 2)}>
                    {/* 4.1 Hallgatói mobilitás szöveg */}
                    <div className="card">
                        <h2>{t.section1.title}</h2>
                        <p>{t.section1.source} <a href="https://seafile.sze.hu/f/41d56a7cfec34a4c9ac6/" target="_blank" rel="noopener noreferrer">https://seafile.sze.hu/f/41d56a7cfec34a4c9ac6/</a></p>
                        <h4>{t.section1.subtitle1}</h4>
                        <div className="form-group">
                            {hallgatokAranyaOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`hallgatok_aranya_${option.value}`}
                                        name="hallgatok_aranya"
                                        value={option.value}
                                        checked={hallgatokAranya === option.value}
                                        onChange={(e) => setHallgatokAranya(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`hallgatok_aranya_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section1.subtitle2}</h4>
                        <div className="form-group">
                            {elozoEvekOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`elozo_evek_${option.value}`}
                                        name="elozo_evek"
                                        value={option.value}
                                        checked={elozoEvek === option.value}
                                        onChange={(e) => setElozoEvek(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`elozo_evek_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section1.subtitle3}</h4>
                        <div className="form-group">
                            {nemzetkoziHallgatokOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`nemzetkozi_hallgatok_${option.value}`}
                                        name="nemzetkozi_hallgatok"
                                        value={option.value}
                                        checked={nemzetkoziHallgatok === option.value}
                                        onChange={(e) => setNemzetkoziHallgatok(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`nemzetkozi_hallgatok_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section1.subtitle4}</h4>
                        <p>{t.section1.description2}</p>
                        <div className="form-group">
                            {mobilitasHozzajarulasaOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`mobilitas_hozzajarulasa_${option.value}`}
                                        name="mobilitas_hozzajarulasa"
                                        value={option.value}
                                        checked={mobilitasHozzajarulasa.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setMobilitasHozzajarulasa([
                                                    ...mobilitasHozzajarulasa,
                                                    option.value
                                                ]);
                                            } else {
                                                setMobilitasHozzajarulasa(
                                                    mobilitasHozzajarulasa.filter(val => val !== option.value)
                                                );
                                            }
                                        }}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`mobilitas_hozzajarulasa_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {mobilitasHozzajarulasa.includes('egyeb') && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="mobilitas_hozzajarulasa_egyeb"
                                        value={mobilitasHozzajarulasaEgyeb}
                                        onChange={setMobilitasHozzajarulasaEgyeb}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    
                    {/* 4.2 Mobilitási ablak */}
                    <div className="card">
                        <h2>{t.section2.title}</h2>
                        <p>{t.section2.description1}</p>
                        <p>{t.section2.description2}</p>
                        <div className="form-group">
                            {mobilitasiAblakOptions.map((option) => (
                                <div className="radio-group" key={option.value}>
                                    <input
                                        type="radio"
                                        id={`mobilitasi_ablak_${option.value}`}
                                        name="mobilitasi_ablak"
                                        value={option.value}
                                        checked={mobilitasiAblak === option.value}
                                        onChange={(e) => setMobilitasiAblak(e.target.value)}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`mobilitasi_ablak_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                        </div>
                        <h4>{t.section2.noteLabel}</h4>
                        <div className="form-group">
                            <RichTextEditor
                                name="mobilitasi_ablak_megjegyzes"
                                value={mobilitasiAblakMegjegyzes} 
                                onChange={handleMobilitasiAblakMegjegyzes}
                                disabled={finalized}
                            />
                        </div>
                        <h4>{t.section2.subtitle}</h4>
                        <div className="form-group">
                            {kreditElismeresOptions.map((option) => (
                                <div className="checkbox-group" key={option.value}>
                                    <input
                                        type="checkbox"
                                        id={`kredit_elismeres_${option.value}`}
                                        name="kredit_elismeres"
                                        value={option.value}
                                        checked={kreditElismeres.includes(option.value)}
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setKreditElismeres([...kreditElismeres, option.value]);
                                            } else {
                                                setKreditElismeres(kreditElismeres.filter(val => val !== option.value));
                                                if (option.value === 'egyeb') {
                                                    setKreditElismeresEgyeb("");
                                                }
                                            }
                                        }}
                                        disabled={finalized}
                                    />
                                    <label htmlFor={`kredit_elismeres_${option.value}`}>{option.label}</label>
                                </div>
                            ))}
                            {kreditElismeres.includes('egyeb') && (
                                <div className="egyeb-editor-container">
                                    <RichTextEditor
                                        name="kredit_elismeres_egyeb"
                                        value={kreditElismeresEgyeb}
                                        onChange={setKreditElismeresEgyeb}
                                        disabled={finalized}
                                    />
                                </div>
                            )}
                        </div>
                    </div>


                    {isHungarian && (
                        <div className="card">
                            <h2>{t.section3.title}</h2>
                            <p>{t.section3.description1} <br></br> </p>
                            <p>{t.section3.source}<a href="https://neptun.sze.hu/on-line-kiadott-tajekoztatok" target="_blank" rel="noopener noreferrer">https://neptun.sze.hu/on-line-kiadott-tajekoztatok</a> {t.section3.description2}</p>
                            <h4>{t.section3.subtitle1}</h4>
                            <div className="form-group">
                               {altalanosNyelviOptions.map((option) => (
                                    <div className="radio-group" key={option.value}>
                                        <input
                                            type="radio"
                                            id={`altalanos_nyelvi_${option.value}`}
                                            name="altalanos_nyelvi"
                                            value={option.value}
                                            checked={altalanosNyelvi === option.value}
                                            onChange={(e) => setAltalanosNyelvi(e.target.value)}
                                            disabled={finalized}
                                        />
                                        <label htmlFor={`altalanos_nyelvi_${option.value}`}>{option.label}</label>
                                    </div>
                                ))} 
                            </div>
                            <h4>{t.section3.subtitle2}</h4>
                            <div className="form-group">
                                {szaknyelviTargyakOptions.map((option) => (
                                    <div className="radio-group" key={option.value}>
                                        <input
                                            type="radio"
                                            id={`szaknyelvi_targyak_${option.value}`}
                                            name="szaknyelvi_targyak"
                                            value={option.value}
                                            checked={szaknyelviTargyak === option.value}
                                            onChange={(e) => setSzaknyelviTargyak(e.target.value)}
                                            disabled={finalized}
                                        />
                                        <label htmlFor={`szaknyelvi_targyak_${option.value}`}>{option.label}</label>
                                    </div>
                                ))}
                            </div>
                            <h4>{t.section3.subtitle3}</h4>
                            <div className="form-group">
                                {idegenNyelvOptions.map((option) => (
                                    <div className="radio-group" key={option.value}>
                                        <input
                                            type="radio"
                                            id={`idegen_nyelv_${option.value}`}
                                            name="idegen_nyelv"
                                            value={option.value}
                                            checked={idegenNyelv === option.value}
                                            onChange={(e) => setIdegenNyelv(e.target.value)}
                                            disabled={finalized}
                                        />
                                        <label htmlFor={`idegen_nyelv_${option.value}`}>{option.label}</label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    <div className="button-container-left">
                        <button className="szak-button" type="button" onClick={handleBack}>{t.buttons.previous}</button>
                        <div className="spacer"></div>
                        <button className="szak-button" type="button" onClick={handleNext}>{t.buttons.next}</button>
                    </div>
                    <div className="szak-button-container">
                        <button className="szak-button" type="submit" disabled={finalized || szakStatus >= 2}>{t.buttons.save}</button>
                        {finalized ? (
                            <button className="szak-button finalize-button" type="button" onClick={handleRevertFinalize} disabled={szakStatus >= 2}>{t.buttons.unfinalize}</button>
                        ) : (
                            <button className="szak-button finalize-button" type="button" onClick={handleFinalize} disabled={szakStatus >= 2}>{t.buttons.finalize}</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
        </div>
    );
};

// Wrapper component to fetch szakKod and provide LanguageContext
const IdegenNyelviKorulmenyek = () => {
    const { szakId } = useParams();
    const [szakKod, setSzakKod] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSzakKod = async () => {
            try {
                console.log('Fetching szakKod for szakId:', szakId);
                const response = await getSzak(szakId);
                console.log('getSzak response:', response);
                const kod = response.data?.szak_kod || response.data?.data?.szak_kod;
                console.log('Extracted szak_kod:', kod);
                setSzakKod(kod);
            } catch (error) {
                console.error("Error fetching szak_kod:", error);
                setError(error.message);
                // Set a default to prevent infinite loading
                setSzakKod('default');
            }
        };
        fetchSzakKod();
    }, [szakId]);

    if (error) {
        return <div>Error loading page: {error}</div>;
    }

    if (!szakKod) {
        return <div>Loading page...</div>;
    }

    return (
        <LanguageProvider szakKod={szakKod}>
            <IdegenNyelviKorulmenyekContent szakKod={szakKod} />
        </LanguageProvider>
    );
};

export default IdegenNyelviKorulmenyek;
